
import { useState, useEffect } from 'react';

/**
 * A custom hook that persists state to localStorage.
 * 
 * @param {string} key - The unique key for the localStorage item.
 * @param {any} initialValue - The initial value if no value resides in localStorage.
 * @returns {[any, Function]} - The state and the state setter function.
 */
function usePersistentState(key, initialValue) {
  const [state, setState] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.warn(`Error reading localStorage key "${key}":`, error);
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(state));
    } catch (error) {
      console.warn(`Error setting localStorage key "${key}":`, error);
    }
  }, [key, state]);

  return [state, setState];
}

export default usePersistentState;
